import { render, staticRenderFns } from "./login12306Content.vue?vue&type=template&id=c809a2c6&scoped=true&"
import script from "./login12306Content.vue?vue&type=script&lang=js&"
export * from "./login12306Content.vue?vue&type=script&lang=js&"
import style0 from "./login12306Content.vue?vue&type=style&index=0&id=c809a2c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c809a2c6",
  null
  
)

export default component.exports